<script>
import CabecalhoRelatorio from './CabecalhoRelatorio.vue';

export default {
  components: { CabecalhoRelatorio },
  props: {
    dados: {
      type: Array,
      required: true,
    },
    projeto: {
      type: Object,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    }
  },
  data() {
    return { RELATORIO_ACOMPANHAMENTO_PROJETO: '8' }
  },
  methods: {
    detalhar(id) {
      this.$router.push({
        name: 'transparencia.projetos.detalhar-acompanhamento-projeto',
        query: this.$route.query,
        params: { id: this.$route.params.id, idAcompanhamentoProjeto: Number.parseInt(id) }
      });
    },
  },
}
</script>

<template>
  <div>
    <cabecalho-relatorio :titulo="titulo" :nomeProjeto="projeto.nomeProjeto" borda=""></cabecalho-relatorio>

    <div class="table-responsive">
      <table class="table relatorio table-bordered table-striped">
        <thead>
          <tr>
            <th>Numero do relatorio</th>
            <th>Início do período do relatório</th>
            <th>Final do período do relatório</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="acompanhamento in dados" :key="acompanhamento.IDAcompanhamentoProjeto" class="linha-clicavel">
            <td @click="detalhar(acompanhamento.IDAcompanhamentoProjeto)">{{ acompanhamento.NumeroRelatorio || '---' }}</td>
            <td @click="detalhar(acompanhamento.IDAcompanhamentoProjeto)">{{ acompanhamento.PeriodoRelatorioInicio | formatarData }}</td>
            <td @click="detalhar(acompanhamento.IDAcompanhamentoProjeto)">{{ acompanhamento.PeriodoRelatorioFim | formatarData }}</td>
          </tr>
          <tr v-if="dados.length === 0">
            <td colspan="7" class="text-center">Não há dados.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style>
.linha-clicavel {
  transition: background-color 0.2s;
}

.linha-clicavel:hover {
  background-color: #f8f9fa; 
  color: #0066cc; 
  text-decoration: none; 
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/RelatorioAcompanhamentoProjeto.vue